import { PASSWORD_MIN_LENGTH } from "@sagot/constants";

/** Live checklist rules (mockups/auth/auth.js `rules`). */
export interface PasswordRules {
  len: boolean;
  case: boolean;
  num: boolean;
  sym: boolean;
  match: boolean;
}

export type PasswordRuleKey = keyof PasswordRules;
export const PASSWORD_RULE_KEYS: readonly PasswordRuleKey[] = ["len", "case", "num", "sym", "match"];

const SHORT_LENGTH = 8;

export function passwordRules(value: string, confirm?: string): PasswordRules {
  return {
    len: value.length >= PASSWORD_MIN_LENGTH,
    case: /[a-z]/.test(value) && /[A-Z]/.test(value),
    num: /\d/.test(value),
    sym: /[^A-Za-z0-9]/.test(value),
    match: confirm !== undefined && value.length > 0 && value === confirm,
  };
}

export type StrengthScore = 0 | 1 | 2 | 3 | 4;

/** 0 = empty; otherwise 1–4 = rules met, capped at 1 below 8 characters (auth.js `score`). */
export function passwordScore(value: string): StrengthScore {
  if (!value) return 0;
  const rules = passwordRules(value);
  let score = [rules.len, rules.case, rules.num, rules.sym].filter(Boolean).length;
  if (value.length < SHORT_LENGTH) score = Math.min(score, 1);
  return Math.max(1, score) as StrengthScore;
}

export function allRulesPass(rules: PasswordRules): boolean {
  return PASSWORD_RULE_KEYS.every((key) => rules[key]);
}
